var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobilityLogbook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.478 21.991",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\t\t\t.mobility-1{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:1.5px;}.mobility-2{fill:#fff;stroke:rgba(0,0,0,0);}\n\t\t"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1276.566 36.331)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "mobility-1",
    d: "M1292.312-19.03c2.979.519,4.983,1.487,4.983,2.593,0,1.655-4.473,3-9.989,3s-9.989-1.343-9.989-3c0-1.1,1.99-2.067,4.953-2.587",
    transform: "translate(0 -1.65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "mobility-2",
    d: "M1287.8-35.831a5.411,5.411,0,0,0-5.411,5.411c0,4.663,5.411,13.14,5.411,13.14s5.411-8.547,5.411-13.14A5.41,5.41,0,0,0,1287.8-35.831Zm0,7.214a1.8,1.8,0,0,1-1.8-1.8,1.8,1.8,0,0,1,1.8-1.8,1.8,1.8,0,0,1,1.8,1.8A1.8,1.8,0,0,1,1287.8-28.617Z",
    transform: "translate(-0.499 0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilityLogbook);
export default __webpack_public_path__ + "static/media/MobilityLogbook.0b869a0a175e80b56c469b9794c886a2.svg";
export { ForwardRef as ReactComponent };